import React from "react";
import { useLottie } from "lottie-react";
import loaderShiftingCars from "../../../Assets/Lottie/loaderShiftingCars.json";
import loaderCarRotation from "../../../Assets/Lottie/loaderCarRotation.json";
import { Text } from "@mantine/core";
import dealershipInfo from "../../../Helpers/currentDealership.jsx/dealershipInfo";
import { dealershipID } from "../../../Helpers/Constants";

const AnimationLoader = () => {
  const options = {
    animationData: loaderShiftingCars,
    loop: true,
  };
  const options2 = {
    animationData: loaderCarRotation,
    loop: true,
  };

  const { View } = useLottie(options);
  const { View: View2 } = useLottie(options2);

  return (
    <div style={{ margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ alignSelf: "center", width: "130px", height: "70px", marginTop: "50px" }}>{View}</div>
      <div
        style={{
          width: "200px",
          height: "200px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: -10,
        }}
      >
        {View2}
      </div>

      <Text size={30} align="center" color="#339AF0" weight={"bolder"} mt={60} style={{ fontFamily: "sans-serif" }}>
        {dealershipInfo[dealershipID || "CLMS"]?.name}
      </Text>
    </div>
  );
};

export default AnimationLoader;
